import { CountryType } from '../const/country.const'

export class SpoonCountry {
  code!: CountryType
}
